import { render, staticRenderFns } from "./IconTestimonialRing.vue?vue&type=template&id=479dd24d&scoped=true&"
import script from "./IconTestimonialRing.vue?vue&type=script&lang=ts&"
export * from "./IconTestimonialRing.vue?vue&type=script&lang=ts&"
import style0 from "./IconTestimonialRing.vue?vue&type=style&index=0&id=479dd24d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479dd24d",
  null
  
)

export default component.exports